import React, {useCallback, useContext, useEffect} from 'react';
import {connect} from 'react-redux';

import _ from 'topmeteo/utils/i18n';

import LightBox from 'topmeteo/general/components/LightBox';

import {DrawingContext} from './Drawing';

const Message = _('You are currently drawing a track. Your track is lost when you change the region. Are you sure?');
const ConfirmLabel = _('Confirm and switch');
const AbortLabel = _('Abort and stay');

const ConfirmRegionChange = ({confirmChange}) => {
    const {waypoints: waypointsRef} = useContext(DrawingContext);
    const {current: waypoints} = waypointsRef;

    const handleClose = useCallback(() => confirmChange.confirm(false), [confirmChange]);
    const handleClick = useCallback(() => confirmChange.confirm(true), [confirmChange]);

    useEffect(
        () => {
            if (confirmChange) {
                const {current: waypoints} = waypointsRef;

                /* automatically confirm, when no waypoints are drawn right now */
                if (waypoints === null || waypoints.length === 0) confirmChange.confirm(true);
            }
        },
        [confirmChange, waypointsRef],
    );

    if (confirmChange === null || waypoints === null || waypoints.length === 0) return null;

    return (
        <LightBox className="confirm-region-change-light-box" onClose={handleClose} hint>
            <p>{Message}</p>
            <div className="buttons">
                <button className="met-btn" onClick={handleClick}>{ConfirmLabel}</button>
                <button className="met-btn" onClick={handleClose}>{AbortLabel}</button>
            </div>
        </LightBox>
    );
};

const mapStateToProps = ({confirmRegionChange}) => ({confirmChange: confirmRegionChange});

export default connect(mapStateToProps)(ConfirmRegionChange);
